import { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetStoredTags } from 'api/queries/getStoredTags.query';

import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/Settings/Components/Tags/components/tags.module.scss';
import { columns, defaultColumn, initialState } from 'components/Settings/Components/Tags/tags.utils';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const Tags = () => {
    const { ability, customerId } = useUserHook();
    const { project } = useProjectTreeStore();
    const {
        data: tags,
        isLoading,
        isFetching,
    } = useQueryGetStoredTags({ enabled: ability.can('view', 'ManageProjects'), customerId, projectId: project?.id });
    const history = useHistory();
    const { pathname } = useLocation();

    const handleNew = () => {
        history.push(`${pathname}/${settingsConfig.tagsNew.link}`);
    };

    const data = useMemo(() => {
        return tags || [];
    }, [tags]);

    return (
        <WidgetWithTitle
            title={'Tags'}
            titleComponents={[
                <div data-testid={'title-actions'} className={classes.titleActions} key={'createTag'}>
                    <Button onClick={handleNew}>Create New Tag</Button>
                </div>,
            ]}
        >
            <div className={classes.container}>
                <MainTable
                    columns={columns}
                    data={data}
                    initialState={initialState}
                    defaultColumn={defaultColumn}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </WidgetWithTitle>
    );
};
